<template>
  <router-link
    :class="className"
    :to="to">
    <slot/>
  </router-link>
</template>

<script>
export default {
  name: 'TextLink',
  props: {
    className: {
      type: String,
      default: '',
    },
    to: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped lang="scss">
a {
  color: $primary;
  &:hover {
    color: $primary-dark;
  }
  -webkit-transition: color 0.1s linear;
  -moz-transition: color 0.1s linear;
  -o-transition: color 0.1s linear;
  -ms-transition: color 0.1s linear;
  transition: color 0.1s linear;
}
</style>
